import { Injectable } from '@angular/core';
import { SharedService } from '../shared/shared.service';
import { appConfig } from '../app.config';
@Injectable()

export class UserProfileService {
    constructor(
        public sharedService: SharedService,
    ) { }

    /**
     * API call for getting user profile details
     */
    getUserProfile() {
        const getUserUrl = appConfig.updateUserProfile;
        return this.sharedService.getData(getUserUrl);
    }

    /**
     * API call for updating user profile
     * @param profileData Updated profile data
     */
    updateUserProfile(profileData) {
        const updateUserUrl = appConfig.updateUserProfile;
        return this.sharedService.putData(updateUserUrl, profileData);
    }

    /**
     * API call for removing user image
     */
    removeProfileImage() {
        const deleteUserImageUrl = appConfig.updateUserImage;
        return this.sharedService.deleteData(deleteUserImageUrl);
    }

}
